module.exports = __webpack_public_path__ + "assets/images/25HBox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25HBox.png
// module id = 1294
// module chunks = 1